import React, { Component } from 'react'
import HashLoader from "react-spinners/HashLoader";

export default class Spinner extends Component {
    render() {
        return (
            <div style={{ padding: '20px' }} className="sweet-loading">
                <HashLoader
                    size={20}
                    color={"#27aae1"}
                    loading={true}
                />
            </div>
        )
    }
}
